/* Binowee Group motion: scroll reveal, counters, film hero, rail arrows, parallax.
   Vanilla, no dependencies. Everything degrades to static content. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const design = window.Shopify && window.Shopify.designMode;

  /* Reveal on scroll */
  const reveal = (root = document) => {
    const els = root.querySelectorAll('[data-bw-reveal]:not(.is-in)');
    if (reduce || design || !('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach((e) => io.observe(e));
  };

  /* Count up */
  const count = (root = document) => {
    const els = root.querySelectorAll('[data-bw-count]');
    if (reduce || design || !('IntersectionObserver' in window)) return;
    const run = (el) => {
      const end = parseFloat(el.dataset.bwCount); if (!isFinite(end)) return;
      const dur = 1600; const t0 = performance.now();
      const step = (t) => { const k = Math.min(1, (t - t0) / dur); const e = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(end * e).toLocaleString('en-AU'); if (k < 1) requestAnimationFrame(step); };
      el.textContent = '0'; requestAnimationFrame(step);
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.6 });
    els.forEach((e) => io.observe(e));
  };

  /* Film hero */
  const film = (root = document) => {
    root.querySelectorAll('[data-bw-film]').forEach((v) => {
      const conn = navigator.connection || {};
      if (reduce || conn.saveData) return;
      const small = window.matchMedia('(max-width: 749px)').matches;
      v.src = small ? v.dataset.srcSmall : v.dataset.src;
      const btn = v.closest('.bw-film').querySelector('[data-bw-film-toggle]');
      v.addEventListener('playing', () => { v.classList.add('is-playing'); if (btn) btn.hidden = false; }, { once: true });
      const p = v.play(); if (p && p.catch) p.catch(() => {});
      if (btn) btn.addEventListener('click', () => {
        if (v.paused) { v.play(); btn.setAttribute('aria-pressed', 'false'); } else { v.pause(); btn.setAttribute('aria-pressed', 'true'); }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => { if (btn && btn.getAttribute('aria-pressed') === 'true') return; if (en.isIntersecting) v.play().catch(() => {}); else v.pause(); }).observe(v);
      }
    });
  };

  /* Still hero: slow push-in, runs once after the image has loaded, pausable */
  const push = (root = document) => {
    root.querySelectorAll('[data-bw-push]').forEach((m) => {
      if (reduce) return;
      const img = m.querySelector('img'); if (!img) return;
      const btn = m.closest('.bw-film').querySelector('[data-bw-film-toggle]');
      const go = () => { if (m.classList.contains('is-moving')) return; m.classList.add('is-moving'); if (btn) btn.hidden = false; };
      if (img.complete && img.naturalWidth) go();
      else {
        img.addEventListener('load', go, { once: true });
        if (img.decode) img.decode().then(go, () => {});
      }
      img.addEventListener('animationend', () => { if (btn) btn.hidden = true; }, { once: true });
      if (btn) btn.addEventListener('click', () => {
        const paused = m.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      });
    });
  };

  /* Product rail arrows */
  const rails = (root = document) => {
    root.querySelectorAll('.bw-rail').forEach((s) => {
      const track = s.querySelector('[data-bw-rail]'); if (!track) return;
      const by = () => Math.max(track.clientWidth * 0.8, 260);
      const prev = s.querySelector('[data-bw-rail-prev]'); const next = s.querySelector('[data-bw-rail-next]');
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -by(), behavior: reduce ? 'auto' : 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: by(), behavior: reduce ? 'auto' : 'smooth' }));
    });
  };

  /* Gentle parallax on story images and page banners */
  const parallax = () => {
    if (reduce) return;
    const els = [...document.querySelectorAll('.bw-parallax')]; if (!els.length) return;
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      els.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const k = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = `translate3d(0, ${(-k * 6 - 6).toFixed(2)}%, 0)`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  };

  const init = (root) => { reveal(root); count(root); film(root); push(root); rails(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { init(); parallax(); }); else { init(); parallax(); }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
